import { render, staticRenderFns } from "./SideNotificationBar.vue?vue&type=template&id=e0032394&scoped=true&lang=pug&"
import script from "./SideNotificationBar.vue?vue&type=script&lang=js&"
export * from "./SideNotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./SideNotificationBar.vue?vue&type=style&index=0&id=e0032394&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0032394",
  null
  
)

export default component.exports